class CollectionBubbles extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-bubbles-track]');
    this.previousButton = this.querySelector('[data-bubbles-previous]');
    this.nextButton = this.querySelector('[data-bubbles-next]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.handlePrevious = () => this.scrollByPage(-1);
    this.handleNext = () => this.scrollByPage(1);
    this.updateControls = () => this.syncControls();

    this.previousButton.addEventListener('click', this.handlePrevious);
    this.nextButton.addEventListener('click', this.handleNext);
    this.track.addEventListener('scroll', this.updateControls, { passive: true });

    this.resizeObserver = new ResizeObserver(this.updateControls);
    this.resizeObserver.observe(this.track);
    this.track.querySelectorAll('.salee-collection-bubble').forEach((bubble) => this.resizeObserver.observe(bubble));

    requestAnimationFrame(this.updateControls);
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.handlePrevious);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.track?.removeEventListener('scroll', this.updateControls);
    this.resizeObserver?.disconnect();
  }

  scrollByPage(direction) {
    const firstBubble = this.track.querySelector('.salee-collection-bubble');
    const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
    const itemWidth = firstBubble ? firstBubble.getBoundingClientRect().width + gap : this.track.clientWidth * 0.75;
    const visibleItems = Math.max(1, Math.floor(this.track.clientWidth / itemWidth));

    this.track.scrollBy({ left: direction * itemWidth * visibleItems, behavior: 'smooth' });
  }

  syncControls() {
    const tolerance = 2;
    const overflows = this.track.scrollWidth > this.track.clientWidth + tolerance;

    this.previousButton.hidden = !overflows;
    this.nextButton.hidden = !overflows;

    if (!overflows) return;

    this.previousButton.disabled = this.track.scrollLeft <= tolerance;
    this.nextButton.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - tolerance;
  }
}

if (!customElements.get('collection-bubbles')) {
  customElements.define('collection-bubbles', CollectionBubbles);
}
